export default __webpack_public_path__ + "static/media/dollar.f2005313.svg";